/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Media_Import_CompleteInputs */



/**
* | output |
* | --- |
* | "Media import completed successfully." |
*
* @param {Team_Project_Import_Media_Import_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_media_import_complete = /** @type {((inputs?: Team_Project_Import_Media_Import_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Media_Import_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du média terminée avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienimport erfolgreich abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione dei media completata con successo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт медиафайлов успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La importación de medios se completó correctamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体导入成功完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのインポートが正常に完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया का आयात सफलतापूर्वक पूरा हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de mídia concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Media import completed successfully.")
});